
export class ProfileDetialsModel{
   public FirstName: string = null;
   public LastName: string = null;
   public CustomerCode: string;   
   public JoiningDate = new Date();
   public CustomerType: string = null;
   public PanNumber: string = null;
   public TINNo: string = null;
   public NoOfCards: number=0;
   public SubCategoryTypeId:number;
   public ContactDetails = new ContactDetailInfoModel();
   public Address = new AddressInfoModel();
}

export class ContactDetailInfoModel{
    public EmailAddress: string = null;
    public MobileNumber: string;
    public IsSMS:boolean;
    public IsEmail:boolean;
    public ContactPersonFirstName: string = null;
    public ContactPersonLastName: string = null;
    public CreatedDate : string = null;
    public PhoneNumber : string = null;
}

export class AddressInfoModel{
    public Address1: string = null;
    public Address2: string = null;
    public CountryId?: number = 0;
    public Country: string = null;
    public StateId?: number = 0;
    public State : string = null;
    public CityId: number = 0;
    public City: string = null;  
    public District: string = null;
    public PinCode: string = null;
    public Location: string = null;
}

export class LocationInfoDetail{
    public LcoationName: string;
    public LocationCode: number;
    public LocationId: number;
    public LocationTypeId: number;
    public ParentLocationId: number;
}


// WEBPACK FOOTER //
// ./src/app/models/ProfileDetailsModel.ts